import {
  ADD_COMMENTS,
  ADD_COMMENTS_PLACEHOLDER,
  ACCEPT,
  CHANGE_LANGUAGE_PROMPT_DESCRIPTION,
  CHANGE_LANGUAGE_PROMPT_TITLE,
  CONFIRMED,
  CONFIRMED_DESCRIPTION,
  EDIT_ORDER,
  FETCHING_ORDER,
  MAKE_ORDER,
  MY_ORDER,
  ORDER,
  PENDING,
  PENDING_DESCRIPTION,
  REJECTED,
  REJECTED_DESCRIPTION,
  REMOVE_ITEM_FROM_ORDER,
  REMOVE_ORDER_PROMPT_DESCRIPTION,
  REMOVE_ORDER_PROMPT_TITLE,
  ROOM,
  SEARCH,
  SELECT,
  SELECT_ROOM,
  SENDING_ORDER,
  SELECT_TABLE,
  SELECT_GETTING_THE_ORDER,
  SELECT_THE,
  SELECT_SEND_TO,
  SEND_TO,
  TABLE,
  TOTAL,
  VIEW_ORDER,
  WRITE_ADDRESS,
  WRITE_ADDRESS_SEND_TO,
  STREET,
  NUMBER,
  APARTMENT_NUMBER,
  STREET_CORNER,
  PHONE_NUMBER,
  PHONE_NUMBER_DESCRIPTION,
  SHIPPING,
  PAYMENT_METHOD,
  CASH,
  MANDATORY,
} from './keys';

const translation = {
  // View Menu
  [ADD_COMMENTS]: 'Añadir comentarios',
  [ADD_COMMENTS_PLACEHOLDER]: 'Escriba hasta 100 caracteres',
  [ACCEPT]: 'Aceptar',
  [CHANGE_LANGUAGE_PROMPT_TITLE]: 'Selección de idioma',
  [CHANGE_LANGUAGE_PROMPT_DESCRIPTION]: 'Seleccione el nuevo idioma de los textos:',
  [CONFIRMED]: 'Confirmado',
  [CONFIRMED_DESCRIPTION]: 'Tu pedido fue confirmado por el local y será entregado en minutos.',
  [EDIT_ORDER]: 'Editar pedido',
  [FETCHING_ORDER]: 'Obteniendo orden...',
  [MAKE_ORDER]: 'Realizar pedido',
  [MY_ORDER]: 'Mi pedido',
  [ORDER]: 'Pedido',
  [PENDING]: 'Pendiente',
  [PENDING_DESCRIPTION]: 'Tu pedido está pendiente de confirmación por parte del local',
  [REJECTED]: 'Rechazado',
  [REJECTED_DESCRIPTION]: 'Tu pedido fue rechazado por el local.',
  [REMOVE_ITEM_FROM_ORDER]: 'Quitar del pedido',
  [REMOVE_ORDER_PROMPT_TITLE]: 'Borrar pedido',
  [REMOVE_ORDER_PROMPT_DESCRIPTION]: '¿Deseas eliminar tu pedido?',
  [ROOM]: 'Habitación',
  [SEARCH]: 'Buscar',
  [SELECT]: 'Seleccione',
  [SELECT_SEND_TO]: 'Seleccione el destino',
  [SELECT_THE]: 'Seleccione',
  [SELECT_GETTING_THE_ORDER]: 'a recibir el pedido.',
  [SELECT_ROOM]: 'Seleccione habitación',
  [SELECT_TABLE]: 'Seleccione mesa',
  [SEND_TO]: 'Enviar a',
  [TABLE]: 'Mesa',
  [TOTAL]: 'Total',
  [SENDING_ORDER]: 'Enviando pedido...',
  [VIEW_ORDER]: 'Ver pedido',
  [WRITE_ADDRESS]: 'Escribe datos de envío',
  [WRITE_ADDRESS_SEND_TO]: 'Datos del envío',
  [STREET]: 'Calle',
  [NUMBER]: 'Número de puerta',
  [APARTMENT_NUMBER]: 'Apartamento',
  [STREET_CORNER]: 'Esquina',
  [PHONE_NUMBER]: 'Teléfono',
  [PHONE_NUMBER_DESCRIPTION]: 'Lo utilizaremos para notificarte el estado del pedido.',
  [SHIPPING]: 'Envío',
  [PAYMENT_METHOD]: 'Forma de pago',
  [CASH]: 'Efectivo / POS',
  [MANDATORY]: 'Obligatorio',
};

export default translation;
